<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Luggage Transfers</h1>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="py-0 mr-2">
        <list-filters
          :filters="filters"
          label="Find luggage transfers"
          ref-name="luggage_transfers_filters"
          :expansionPanel="false"
          @searchParamsChanged="onFiltersChange"
        ></list-filters>
      </v-col>
      <v-btn
        small
        text
        color="primary"
        class="mr-2"
        :loading="exporting"
        :disabled="legs.length === 0"
        @click="exportAll"
      >
        <v-icon small left>mdi-download</v-icon>Export all
      </v-btn>
      <v-btn
        small
        text
        color="primary"
        :loading="exporting"
        :disabled="selected.length === 0"
        @click="exportSelected"
      >
        <v-icon small left>mdi-download</v-icon>Export selected ({{
          selected.length
        }})
      </v-btn>
    </v-row>

    <v-row>
      <v-col class="pa-0">
        <v-data-table
          v-model="selected"
          class="elevation-1"
          :headers="headers"
          :items="legs"
          :loading="$apollo.loading"
          :items-per-page="25"
          :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
          item-key="id"
          show-select
          dense
        >
          <template v-slot:[`item.date`]="{ item }">
            <v-icon
              v-if="item.gapWarning"
              small
              color="warning"
              class="mr-1"
              title="Gap night / pickup hotel not matched — please check"
              >mdi-alert</v-icon
            >
            {{ formatDate(item.date) }}
          </template>
          <template v-slot:[`item.pickup`]="{ item }">
            <div>{{ item.pickupLocation || "—" }}</div>
            <div class="grey--text caption" v-if="item.pickupAddress">
              {{ item.pickupAddress }}
            </div>
          </template>
          <template v-slot:[`item.dropoffDate`]="{ item }">
            {{ formatDate(item.date) }}
          </template>
          <template v-slot:[`item.dropoff`]="{ item }">
            <div>{{ item.dropoffLocation || "—" }}</div>
            <div class="grey--text caption" v-if="item.dropoffAddress">
              {{ item.dropoffAddress }}
            </div>
          </template>
          <template v-slot:[`item.participants`]="{ item }">
            {{ (item.assignedParticipants || []).length }}
          </template>
          <template v-slot:[`item.included`]="{ item }">
            <v-icon v-if="item.included" small color="success"
              >mdi-check</v-icon
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListFilters from "../../shared/list-filters/ListFilters";
import listFilters from "./list-filters";
import {
  LUGGAGE_TRANSFERS,
  EXPORT_LUGGAGE_TRANSFERS,
} from "../../../../constants/graphql";
import { removeGQLTypename } from "../../../../helpers/index";
const moment = require("moment");

export default {
  name: "luggage-transfers-plugin",

  components: { ListFilters },

  data() {
    return {
      luggageTransfers: null,
      selected: [],
      exporting: false,
      searchParams: {},
      headers: [
        { text: "Itinerary ref", value: "itineraryRef" },
        { text: "Pick up date", value: "date" },
        { text: "Pick up", value: "pickup", sortable: false },
        { text: "Pick up tel", value: "pickupTel", sortable: false },
        { text: "Drop off date", value: "dropoffDate", sortable: false },
        { text: "Drop off", value: "dropoff", sortable: false },
        { text: "Drop off tel", value: "dropoffTel", sortable: false },
        { text: "Participants", value: "participants", sortable: false },
        { text: "Bags", value: "bags", sortable: false },
        { text: "Included", value: "included", sortable: false },
      ],
    };
  },

  computed: {
    legs() {
      return this.luggageTransfers && this.luggageTransfers.edges
        ? this.luggageTransfers.edges.map((e) => removeGQLTypename(e.node))
        : [];
    },
    filters() {
      return listFilters.map((f) => {
        f.props.outlined = this.$store.getters.localSettings("outlinedInputs");
        return f;
      });
    },
  },

  methods: {
    formatDate(d) {
      if (!d) return "";
      return moment(d).format(this.$store.getters.userConfig.dateFormat);
    },
    onFiltersChange(filters) {
      // drop empty/null keys so the backend filter stays clean
      const clean = {};
      Object.keys(filters || {}).forEach((k) => {
        const v = filters[k];
        if (v !== null && v !== undefined && v !== "") clean[k] = v;
      });
      this.searchParams = clean;
      this.selected = [];
    },
    runExport(variables) {
      this.exporting = true;
      this.$apollo
        .mutate({ mutation: EXPORT_LUGGAGE_TRANSFERS, variables })
        .then((res) => {
          const r = res.data.exportLuggageTransfers;
          if (r && r.success) {
            window.open(r.message);
          } else {
            this.$store.dispatch("showAppSnackbar", {
              msg: (r && r.error) || "Export failed",
              color: "error",
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: err.message || String(err),
            color: "error",
          });
        })
        .finally(() => {
          this.exporting = false;
        });
    },
    exportAll() {
      this.runExport({ filter: this.searchParams });
    },
    exportSelected() {
      this.runExport({ ids: this.selected.map((l) => l.id) });
    },
  },

  apollo: {
    luggageTransfers: {
      query: LUGGAGE_TRANSFERS,
      variables() {
        return { filter: this.searchParams, first: 2000 };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/plugins/luggage-transfers/LuggageTransfersPlugin.vue